import React, {useEffect} from "react";

import "../../../../ui-styles/fileView/FileView.css";
import "../../../../ui-styles/bottomSlider/BottomDetailsSlide.css";

const BannerModal = (props) => {
    useEffect(() => {
        document.body.classList.add('noScroll');
        return () => {
            document.body.classList.remove('noScroll');
        }
    }, [])

    const { current, total, data } = props;

    const handleNext = () => {
        props.handleChange(current + 1);
    }
    const handlePrev = () => {
        props.handleChange(current - 1);
    }

    // prev current > 0

    // next total - 1 > current

    
    return (
        <div className={props.data ? "btmDtlSlider visible" : "btmDtlSlider"}>
            {current > 0 && <div className="leftSlideBtn" onClick={handlePrev}></div>}
            {total - 1 > current && <div className="rightSlideBtn" onClick={handleNext}></div>}
            <div className="fileViewWrapper">
                <div className="fvHdrCntnr">
                    <div className="fileViewHeader">
                        <div className="fileTxtRow">
                            <span className="fileHdrTxtL">{data.uploadname}</span>
                        </div>
                    </div>
                    <div className="fileHdrActn" onClick={props.handleClose}></div>
                </div>

                <div className="mediaBdyCntnr">

                    <div className="mediaBdy">
                        <div className="mediaViewBox">
                            <div className="mediaFileContainer">
                                <img src={data.uploadkey ? `https://${process.env.REACT_APP_s3}.s3.${process.env.REACT_APP_s3Region}.amazonaws.com/${data.uploadkey}` : data.url} alt="banner" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerModal;